import { PatientSexEnum } from "requests";

export const SEX_TO_TITLE = {
  [PatientSexEnum.Female]: "Female intact",
  [PatientSexEnum.Male]: "Male intact",
  [PatientSexEnum.SpayedFemale]: "Female spayed",
  [PatientSexEnum.NeuteredMale]: "Male neutered"
};

export const KG_TO_LBS = 2.2046226218;
